import * as React from 'react';
import { DateInput, IDateInputValue, FormCell, SpaceWrapper, BodyText } from 'ui-toolkit';
import { DateTime } from 'luxon';
import styled from 'styled-components';
import { IMetadata, IStandardDocumentData } from 'types/order/documents/shared/interfaces';
import {
  DocumentCategoriesByName,
  requiresGoodThroughDate,
} from '../../../../types/order/documents/IDocumentCategoryType';

const StyledDocumentData = styled.div`
  display: grid;
  gap: ${(props) => props.theme.spacing.spacing5};
`;

export interface IDocumentDataProps {
  document?: Partial<Pick<IStandardDocumentData, 'category' | 'metadata'>>;
  formValue: IMetadata | null;
  errorText: string | null;
  onChange: (output: IMetadata) => void;
  showInputs?: boolean;
  documentCategoriesByName: DocumentCategoriesByName;
}

export const DocumentData: React.FC<IDocumentDataProps> = ({
  document,
  formValue,
  errorText,
  onChange,
  showInputs,
  documentCategoriesByName,
}) => {
  if (document) {
    if (requiresGoodThroughDate(document.category, documentCategoriesByName)) {
      const goodThroughDate = formValue ? formValue.good_through_date || null : null;
      const onGoodThroughDateChange = (value: IDateInputValue) => {
        if (formValue && formValue.good_through_date) {
          const date =
            value.value && DateTime.fromISO(value.value).isValid
              ? DateTime.fromISO(value.value).toISO()
              : value.value || undefined;
          onChange({
            ...formValue,
            good_through_date: date,
          });
        } else {
          if (value.value) {
            onChange({
              ...formValue,
              good_through_date: DateTime.fromISO(value.value).toISO(),
            });
          }
        }
      };
      return (
        <StyledDocumentData>
          <SpaceWrapper leftSpace={'none'} rightSpace={'none'}>
            {showInputs ? (
              <DateInput
                label="Good Through Date"
                value={goodThroughDate}
                errorText={errorText}
                onChange={onGoodThroughDateChange}
                isRequired
                zIndex={201} //Modal is set to 200 so we need to be higher.
              />
            ) : (
              <FormCell label="Good Through Date">
                {formValue && formValue.good_through_date
                  ? DateTime.fromISO(formValue.good_through_date).toFormat('D')
                  : '-'}
              </FormCell>
            )}
          </SpaceWrapper>
        </StyledDocumentData>
      );
    } else {
      return <BodyText>This document doesn't have editable fields!</BodyText>;
    }
  } else {
    return <></>;
  }
};
